export default "__VITE_PUBLIC_ASSET__b4a3a61d__"